import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/documents',
            name: 'documents',
            component: () => import("./views/documents.vue"),
            meta: {
                hasBar: true
            }
        },
    ];
};